import { useEffect } from 'react';

const CANONICAL_ORIGIN = 'https://www.jobfitai.org';

function upsertMetaTag(attributeName, attributeValue) {
  let tag = document.head.querySelector(`meta[${attributeName}="${attributeValue}"]`);
  const existed = Boolean(tag);

  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attributeName, attributeValue);
    document.head.appendChild(tag);
  }

  return { tag, existed };
}

function upsertCanonicalTag() {
  let tag = document.head.querySelector('link[rel="canonical"]');
  const existed = Boolean(tag);

  if (!tag) {
    tag = document.createElement('link');
    tag.setAttribute('rel', 'canonical');
    document.head.appendChild(tag);
  }

  return { tag, existed };
}

function buildCanonicalUrl(path) {
  const normalizedPath = path === '/' ? '/' : `/${String(path || '').replace(/^\/+|\/+$/g, '')}`;
  return `${CANONICAL_ORIGIN}${normalizedPath}`;
}

export default function SeoHead({ title, description, canonicalPath, robots = 'index,follow' }) {
  useEffect(() => {
    const previousTitle = document.title;

    const descriptionState = upsertMetaTag('name', 'description');
    const previousDescription = descriptionState.tag.getAttribute('content');

    const robotsState = upsertMetaTag('name', 'robots');
    const previousRobots = robotsState.tag.getAttribute('content');

    const canonicalState = upsertCanonicalTag();
    const previousCanonical = canonicalState.tag.getAttribute('href');

    if (title) {
      document.title = title;
    }
    if (description) {
      descriptionState.tag.setAttribute('content', description);
    }
    if (robots) {
      robotsState.tag.setAttribute('content', robots);
    }
    if (canonicalPath) {
      canonicalState.tag.setAttribute('href', buildCanonicalUrl(canonicalPath));
    }

    return () => {
      document.title = previousTitle;

      if (previousDescription === null) {
        if (!descriptionState.existed) {
          descriptionState.tag.remove();
        } else {
          descriptionState.tag.removeAttribute('content');
        }
      } else {
        descriptionState.tag.setAttribute('content', previousDescription);
      }

      if (previousRobots === null) {
        if (!robotsState.existed) {
          robotsState.tag.remove();
        } else {
          robotsState.tag.removeAttribute('content');
        }
      } else {
        robotsState.tag.setAttribute('content', previousRobots);
      }

      if (previousCanonical === null) {
        if (!canonicalState.existed) {
          canonicalState.tag.remove();
        } else {
          canonicalState.tag.removeAttribute('href');
        }
      } else {
        canonicalState.tag.setAttribute('href', previousCanonical);
      }
    };
  }, [title, description, canonicalPath, robots]);

  return null;
}
